import { Component, OnInit, AfterViewInit, OnDestroy, Inject, ChangeDetectorRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd, ActivatedRoute, NavigationStart } from '@angular/router';

import { RoutePartsService } from "./shared/services/route-parts.service";
import { DOCUMENT } from '@angular/common';
import { Loading } from './shared/helpers/loading.helper';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { IdentityAuthService } from './auth/services/identity-auth.service';
import { JwtAuthService } from './auth/services/jwt-auth.service';
import { LoginSuccess, PageRefreshTokenRefresh } from './root-store/auth/auth.action';
import { Store } from '@ngxs/store';
import { LanguageService } from './shared/services/language.service';
import { LocalStoreService } from './shared/services/local-store.service';
// import { LayoutService } from './shared/services/layout.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  appTitle = 'Metaregistar';
  pageTitle = '';
  private subscriptions: Subscription[] = [];
  private storageListener: (event: StorageEvent) => void;
  loading = false;

  constructor(
    public title: Title,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private routePartsService: RoutePartsService,
    private translateService: TranslateService,
    private ngxLoaderService: NgxUiLoaderService,
    private localStorageService: LocalStoreService,
    private identityAuthService: IdentityAuthService,
    private jwtService: JwtAuthService,
    private changeDetectorRef: ChangeDetectorRef,
    private store: Store,
    @Inject(DOCUMENT) private dom: Document
  ) {

    this.subscriptions.push(router.events
      .pipe(filter((rs): rs is NavigationEnd => rs instanceof NavigationEnd))
      .subscribe(event => {
        if (
          event.id === 1 &&
          event.url === event.urlAfterRedirects
        ) {
          this.store.dispatch(new PageRefreshTokenRefresh());
        }
      }));

    this.subscriptions.push(Loading.onChange.subscribe(isLoading => {
      this.loading = isLoading;
      this.changeDetectorRef.detectChanges();
    }));
  }

  public setDefaultLanguage() {
    let language = localStorage.getItem(LanguageService.LANG_CACHE_KEY);
    if (!!!language) {
      language = LanguageService.LANG_SR_CYRL_RS;
      localStorage.setItem(LanguageService.LANG_CACHE_KEY, LanguageService.LANG_SR_CYRL_RS);
    }

    this.translateService.setDefaultLang(language);
    this.translateService.use(language);
  }

  ngOnInit() {
    this.setDefaultLanguage();
    this.changePageTitle();
    this.setCSSstyles();

    this.storageListener = (event: StorageEvent) => {
      const tokenKljuc = this.jwtService.JWT_TOKEN;
      const tokenObrisan = event.key === tokenKljuc && event.newValue === null;
      const sveCisceno = event.key === null;
      if ((tokenObrisan || sveCisceno) && this.jwtService.isLoggedIn() === false) {
        this.jwtService.signout();
        return;
      }

      // Drugi tab je uspesno osvezio token — preuzmi novi token bez poziva backenda
      if (event.key === this.jwtService.APP_USER && event.newValue !== null) {
        const noviPodaci = JSON.parse(event.newValue);
        this.jwtService.setUserAndToken(noviPodaci);
        this.jwtService.user$.next(noviPodaci);
        this.store.dispatch(new LoginSuccess(noviPodaci, true));
      }
    };
    window.addEventListener('storage', this.storageListener);
  }

  ngAfterViewInit() {
  }

  changePageTitle() {
    this.subscriptions.push(this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((routeChange) => {
      var routeParts = this.routePartsService.generateRouteParts(this.activeRoute.snapshot);
      if (!routeParts.length)
        return this.title.setTitle(this.appTitle);
      // Extract title from parts;
      this.pageTitle = routeParts
        .reverse()
        .map((part) => part.title)
        .reduce((partA, partI) => { return `${partA} > ${partI}` });
      this.pageTitle += ` | ${this.appTitle}`;
      this.title.setTitle(this.pageTitle);
    }));
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    window.removeEventListener('storage', this.storageListener);
  }

  setCSSstyles() {
    const link: HTMLLinkElement = this.dom.createElement('link');
    const linkIcon: HTMLLinkElement = this.dom.createElement('link');
    linkIcon.setAttribute('rel', 'icon');
    linkIcon.setAttribute('type', 'image/x-icon');
    link.setAttribute('rel', 'stylesheet');

    let cssStyleLink = "./assets/styles/custom_style.css";

    link.setAttribute("href", cssStyleLink);
    this.dom.head.appendChild(link);
  }
}
